import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Session from './auth/Session';

/**
 * ProtectedRoute
 * Wraps a React Router <Route> and redirects to /login if no valid session exists.
 * Usage:
 *   <ProtectedRoute path="/dashboard" component={Dashboard} />
 */
export function ProtectedRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => {
                const token = Session.getToken();
                if (!token) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location },
                            }}
                        />
                    );
                }
                return <Component {...props} />;
            }}
        />
    );
}